export default __webpack_public_path__ + "static/media/logo_320.3f08a23c.png";